<template>
  <section class="monitordetail">
    <div class="title">
      {{ Monitor.MonitorName
      }}<van-icon @click="OnStopMessageClick" name="edit" />
    </div>
    <van-list v-model="loading" :finished="finished" finished-text="没有更多了" @load="onLoad">
      <van-cell v-for="(item, index) in list" :key="index" :title="item.UpdateTime">
        <div class="cell cell2" :class="
            item.Tem > Monitor.T_High || item.Channel1 < Monitor.T_Low
              ? 'out'
              : ''
          ">
          温度：{{ item.Tem }}
        </div>
        <div class="cell cell2" :class="
            item.Hum > Monitor.H_High || item.Channel2 < Monitor.H_Low
              ? 'out'
              : ''
          ">
          湿度：{{ item.Hum }}
        </div>
      </van-cell>
    </van-list>
    <van-dialog v-model:show="dialogStopMessageVisible" title="暂停消息设置" show-cancel-button @confirm="OnSubmitClick">
      <van-form :submit-on-enter="false">
        <van-cell-group inset>
          <van-field name="radio" label="设备">
            <template #input>
              <van-radio-group v-model="StopType" direction="horizontal">
                <van-radio name="1">仅本设备</van-radio>
                <van-radio name="2">全部设备</van-radio>
              </van-radio-group>
            </template>
          </van-field>
          <van-field name="stepper" label="暂停时间">
            <template #input>
              <van-stepper input-width="4rem" v-model="StopMinute" /><span>分钟</span>
            </template>
          </van-field>
        </van-cell-group>
      </van-form>
    </van-dialog>
  </section>
</template>
<script>
import mixin from "js/mixin";
import { BzAjax, BzJs, BzUser, BzMsg, BzDate } from "@/modules/js/helper";
export default {
  data() {
    return {
      list: [],
      loading: false,
      finished: false,
      pageNo: 0,
      pageSize: 20,
      Monitor: {},
      PositionIndex: "",
      BeginDate: "",
      EndDate: "",
      openid: "",
      dialogStopMessageVisible: false,
      StopType: "1",
      StopMinute: 1,
    };
  },
  created() {
    this.EndDate = BzDate.format(new Date(), "yyyy-MM-dd");
    this.BeginDate = BzDate.addHours(this.EndDate, -72);
    this.MonitorID = this.$route.params.MonitorID;
    this.openid = this.$route.params.openid;
    this.initMonitor();
  },
  methods: {
    OnSubmitClick() {
      BzAjax.post("/WSD/MessageOpen/SetStopMessageTime", {
        StopType: this.StopType,
        StopMinute: this.StopMinute,
        MonitorId: this.MonitorID,
        openid: this.openid,
      }).then((res) => {
        this.dialogStopMessageVisible = false;
        BzMsg.ShowToast("设置成功");
      });
    },
    OnStopMessageClick() {
      this.dialogStopMessageVisible = true;
    },
    initMonitor() {
      BzAjax.post("/WSD/HistoryDataAllOpen/GetMonitor", {
        Id: this.MonitorID,
      }).then((d) => {
        this.Monitor = d;
      });
    },
    onLoad() {
      this.pageNo++;
      this.getlist();
    },
    getlist: function () {
      if (this.pageNo == 1) this.PositionIndex = "";
      BzAjax.post("/WSD/HistoryDataAllOpen/GetHistoryDataList", {
        MonitorID: this.MonitorID,
        PageNo: this.pageNo,
        PageSize: this.pageSize,
        BeginDate: this.BeginDate,
        EndDate: this.EndDate,
        PositionIndex: this.PositionIndex,
      }).then((d) => {
        // console.log(JSON.stringify(d))
        this.PositionIndex = d.PositionIndex;
        if (this.pageNo == 1) {
          this.list = d.Models;
        } else this.list = this.list.concat(d.Models);
        // 加载状态结束
        this.loading = false;
        if (d.Models.length == 0) {
          this.finished = true;
        }
      });
    },
  },
};
</script>
<style lang="less">
.monitordetail {
  .title {
    padding: 1rem;
    text-align: center;
    font-size: 1.5rem;
    font-weight: 1000;
  }
  .out {
    color: red;
  }
}
</style>


// WEBPACK FOOTER //
// src/pages/home/WarnMonitorDetail.vue